<template>
  <div class="register">
    <div class="register-title">{{ $t('login.title') }}</div>
    <div class="register-form">
      <lls-form :model="regRuleForm" :rules="regRuleFormRules" ref="regRuleFormRef">
        <!-- 企业名称 -->
        <lls-form-item prop="companyName" :label="$t('login.register.companyName')">
          <lls-input
            v-model="regRuleForm.companyName"
            autocomplete="off"
            maxlength="140"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <!-- 联系人 -->
        <lls-form-item :label="$t('login.register.name')" :required="true">
          <div class="name-class" :class="{'name-class--zh': $i18n.locale === 'zh'}">
            <lls-form-item prop="firstName">
              <lls-input
                type="text"
                v-model="regRuleForm.firstName"
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('login.register.firstName')"
              ></lls-input>
            </lls-form-item>
            <lls-form-item prop="lastName">
              <lls-input
                type="text"
                v-model="regRuleForm.lastName"
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('login.register.lastName')"
              ></lls-input>
            </lls-form-item>
          </div>
        </lls-form-item>
        <!-- 手机号 -->
        <!-- :required="regRuleForm.phoneAreaCode || regRuleForm.telephone" -->
        <lls-form-item :label="$t('login.register.phone')" :required="regRuleForm.telephone !== '' || regRuleForm.phoneAreaCode !== ''">
          <div class="telephone-class">
            <lls-form-item
              prop="phoneAreaCode"
              :rules="regRuleForm.telephone ? regRuleFormRules.phoneAreaCode : [{}]"
            >
              <lls-select 
                v-model="regRuleForm.phoneAreaCode" 
                filterable
                clearable
                :placeholder="$t('common.Select')"
                popper-class="country-code-drop"
                @change="clearValidate"
                :filter-method="fitlerCountry">
                <lls-option
                  v-for="item in countryCodeList"
                  :key="item.countryCode"
                  :label="'+' + item.phoneCode"
                  :value="item.phoneCode">
                  <span>{{ '+' + item.phoneCode + ' ' + ($i18n.locale === 'zh' ? item.chineseName : item.englishName) }}</span>
                </lls-option>
              </lls-select>
            </lls-form-item>
            <lls-form-item 
              prop="telephone"
              :rules="regRuleForm.phoneAreaCode ? regRuleFormRules.telephone : [{}]"
            >
              <lls-input
                type="text"
                v-model="regRuleForm.telephone"
                maxlength="20"
                autocomplete="off"
                @input="
                  handlerInput
                "
                :placeholder="$t('common.inputPlaceholder')"
              ></lls-input>
            </lls-form-item>
          </div>
        </lls-form-item>
        <!-- 企业邮箱 -->
        <lls-form-item prop="email" :label="$t('login.register.email')">
          <lls-input
            v-model="regRuleForm.email"
            autocomplete="off"
            maxlength="200"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>

        <!-- 密码 -->
        <lls-form-item prop="password" :label="$t('login.register.password')" ref="password">
          <pswValidatePopover>
            <lls-input
              show-password
              v-model="regRuleForm.password"
              autocomplete="new-password"
              :placeholder="$t('common.inputPlaceholder')"
            ></lls-input>
          </pswValidatePopover>
        </lls-form-item>
        <!-- 验证码 -->
        <lls-form-item
          prop="verificationCode"
          class="test"
          :label="$t('login.register.emailCode')"
          ref="verificationCode"
        >
          <lls-input
            class="appand-input"
            v-model="regRuleForm.verificationCode"
            :placeholder="$t('common.inputPlaceholder')"
            autocomplete="off"
          >
            <template slot="append">
              <lls-button
                type="text"
                class="send-button"
                :loading="loadingSend"
                :disabled="disabledSend"
                @click="handleSendCode"
              >{{ codeText }}</lls-button>
            </template>
          </lls-input>
        </lls-form-item>
      </lls-form>
    </div>
    <div class="register-agree">
      <lls-checkbox v-model="isAgree" class="login-text-agree-check"></lls-checkbox>
      <span class="register-agree-text">
        <span>{{ $t('login.agree') }}</span>
        <lls-link @click="handleViewAgreement" class="text-terms">{{ $t('login.userAgreement') }}</lls-link>
        {{ $t('login.and') }}
        <lls-link class="text-terms" @click="handleViewPolicy">{{ $t('login.privacyPolicy') }}</lls-link>
      </span>
    </div>
    <lls-button
      class="register-btn"
      type="primary"
      :loading="loading"
      @click="handleRegist"
      :disabled="!isAgree"
    >{{ $t('login.signUp') }}</lls-button>
    <div class="register-switch" @click="switchRegister">
      <span>{{ $t('login.hasAccount') }}</span>
      <span class="hight-light">{{ $t('login.loginNow') }}</span>
    </div>
  </div>
</template>
<script>
import pswValidatePopover from '@/components/pswValidatePopover/index.vue'
import { testPortalPassword } from '@/utils/portalPasswordRules'
export default {
  name: 'Register',
  components: {
    pswValidatePopover,
  },
  props: {},
  data() {
    var validatePassEmail = (rule, value, callback) => {
      var regEmail = new RegExp(
        /^[a-zA-Z0-9\.!#\$%&\'\*\+\/=\?_`\{\|\}\~\-\(\)\$\%\\\|\/\,\<\>\^]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      )
      if (value === '') {
        // 请输入邮箱
        callback(new Error(this.$t('login.jsCheck.email')))
      } else if (!regEmail.test(value)) {
        // 邮箱格式错误
        callback(new Error(this.$t('login.jsCheck.emailFormat')))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value && !testPortalPassword(value)) {
        // 密码格式错误
        callback(new Error(this.$t('login.jsCheck.passwordFormat')))
      } else {
        callback()
      }
    }
    return {
      allOptions:[],
      countryCodeList:[],
      isAgree: false,
      loading: false,
      regRuleForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        verificationCode: '',
        companyName: '',
        telephone: '',
        phoneAreaCode:''
      },
      regRuleFormRules: {
        telephone:[
          {
            required: true,
            message: this.$t('login.jsCheck.telephone'),
            trigger: ['change', 'blur'],
          },
        ],
        phoneAreaCode:[
          {
            required: true,
            message: this.$t('login.jsCheck.phoneAreaCode'),
            trigger: ['change', 'blur'],
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$t('login.jsCheck.companyName'),
            trigger: ['change', 'blur'],
          },
        ],
        // 请输入联系人
        firstName: [
          {
            required: true,
            message: this.$t('login.jsCheck.firstName'),
            trigger: ['change', 'blur'],
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t('login.jsCheck.lastName'),
            trigger: ['change', 'blur'],
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('login.jsCheck.email'),
            trigger: ['change', 'blur'],
          },
          { validator: validatePassEmail, trigger: ['change', 'blur'] },
        ],
        // 请输入密码
        password: [
          {
            required: true,
            message: this.$t('login.jsCheck.password'),
            trigger: ['change', 'blur'],
          },
          { validator: validatePassword, trigger: ['change', 'blur'] },
        ],

        // 请输入验证码
        verificationCode: [
          {
            required: true,
            message: this.$t('login.jsCheck.verCode'),
            trigger: ['change', 'blur'],
          },
        ],
      },
      count: 0,
      timer: null,
      loadingSend: false,
    }
  },

  // 计算属性
  computed: {
    codeText() {
      return this.count > 0 ? this.count + 's' : this.$t('login.sendCode')
    },
    disabledSend() {
      if (!this.regRuleForm.email) return true
      if (this.count > 0) return true
      return false
    },
  },
  // 监听属性
  watch: {},
  // 生命周期 - 创建完成(访问当前this实例)
  created() {},
  // 生命周期 - 挂载完成(访问DOM元素)
  mounted() {
    this.getCountryCodeList()  
  },
  // 方法集合
  methods: {
    async getCountryCodeList(){
      const res = await this.$http.get(
        ' /kj-kyc/country/listPhoneAreaCode'
      )
      if (res.data.code !== '200') return
      this.countryCodeList = res.data.data
      this.allOptions = this.countryCodeList
    },
    handlerInput(value){ 
      this.regRuleForm.telephone = value.replace(/[^\d]/g, '')
      this.clearValidate()
    },
    async clearValidate(){
      if(!this.regRuleForm.telephone && !this.regRuleForm.phoneAreaCode){
        await this.$refs.regRuleFormRef.clearValidate(['telephone','phoneAreaCode'])
      }
    },
    fitlerCountry(val){
      val = val.toLowerCase()
      if(val.includes("+")) {
        this.countryCodeList = this.allOptions
        return
      }
      if(val){
        this.countryCodeList = this.allOptions.filter(item=>item.phoneCode.includes(val) || (this.$i18n.locale === 'zh' ? item.chineseName.toLowerCase() : item.englishName.toLowerCase()).includes(val))
      } else {
        this.countryCodeList = this.allOptions
      }
    },
    switchRegister() {
      this.$emit('switch')
    },
    handleRegist() {
      this.$refs.regRuleFormRef.clearValidate()
      this.$refs.regRuleFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        const {
          firstName,
          lastName,
          password,
          verificationCode,
          companyName,
          telephone,
          email,
          phoneAreaCode
        } = this.regRuleForm
        const { publicKey, serialNo } = await this.getPublicKey()
        const encodePwd = this.encryptedData(password, publicKey)
        let rawChannelId = this.$route.query.channelId || ''
        let decodedChannelId = decodeURIComponent(rawChannelId)
        const channelId = decodedChannelId.replace(/ /g, '+')
        this.$http({
          method: 'post',
          url: `/kj-kyc/userEnroll/enroll`,
          data: {
            // name: firstName + ' ' + lastName,
            firstName,
            lastName,
            email,
            telephone,
            companyName,
            verificationCode,
            serialNo,
            channelId,
            phoneAreaCode,
            password: encodePwd,
            productType: 'DEFAULT_PRODUCT',
            ssoConstants: 'kj_my_pc',
          },
        })
          .then(({ data }) => {
            if (data.code !== '200') return
            this.$message.success(this.$t('login.register.success'))
            this.$emit('switch')
            // TODO 清空表单
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    handleViewAgreement() {
      this.$emit('view')
    },
    handleViewPolicy() {
      this.$emit('handlePolicyUrl')
    },
    getVerificationCode() {
      if (this.count > 0) {
        return
      } else {
        let _this = this
        let email = this.ForgetruleForm.email
        if (!email) {
          // 请输入邮箱
          this.msgErr = this.$t('login.pleaseEnterEmail')
          return
        }
        if (_this.sentding) return
        _this.sentding = true
        _this.$http
          .get(`/kj-sys/setting/sendForgetPwdCodeForDigipo?email=${email}`)
          .then(
            function(data) {
              _this.sentding = false
              // 验证码已发送，请查收
              _this.$message({
                message: _this.$t('login.verificationSentInbox'),
                type: 'success',
              })
              _this.countDown()
            },
            function(response) {
              _this.sentding = false
            }
          )
      }
    },
    handleSendCode() {
      if (this.count > 0) return
      const { email } = this.regRuleForm
      if (!email) return
      this.loadingSend = true
      this.$http({
        method: 'post',
        url: `/kj-kyc/userEnroll/sendVerificationCode`,
        data: { email },
      })
        .then(({ data }) => {
          if (data.code !== '200') return
          this.$message.success(this.$t('login.verificationSentInbox'))
          this.startCountDown()
          this.loadingSend = false
        })
        .catch(() => {
          this.loadingSend = false
        })
    },
    startCountDown() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    async getPublicKey() {
      // TODO channel 未确定
      const { data } = await this.$http.post(
        '/kj-web/public/getPublicKey?channel=account'
      )
      if (data.code !== '200') return
      return data.data
    },
  },
}
</script>
<style lang="scss">
.country-code-drop {
  width: 300px !important;
}
</style>
<style lang="scss" scoped>
@mixin underline-link {
  text-decoration: underline;
  cursor: pointer;
}
.register {
  width: 100%;
  margin-bottom: 32px;
  overflow: hidden;
  color: #000;
  display: flex;
  flex-direction: column;
  .name-class {
    width: 100%;
    display: flex;
    gap: 8px;
    ::v-deep .lls-form-item {
      flex: 1;
      min-width: 0;
    }
    &--zh {
      flex-direction: row-reverse;
    }
    .name-sub-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }
  }
  .telephone-class{
    width: calc(100% - 8px)  !important;
    display: flex;
    .lls-input {
      margin-left: 5px;
    }
    .lls-form-item:nth-of-type(1){
      width: 40%;
      min-width: 100px;
      .lls-select {
        width: 100% !important;
      }
    }
  }
  &-title {
    font-family: 'Open Sans';
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 32px;
  }
  &-switch {
    font-size: 12px;
    cursor: pointer;
    .hight-light {
      color: #3e8cfa;
    }
  }
  &-btn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0;
    border-radius: 16px;
    margin: 16px 0;
    &.is-disabled {
      color: #fff;
      background: #c8c9cc;
      border-color: #c8c9cc;
      &:hover {
        color: #fff;
        background: #c8c9cc;
        border-color: #c8c9cc;
      }
    }
  }
  &-agree {
    display: flex;
    &-text {
      margin-left: 4px;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      span {
        white-space: nowrap;
      }
      .text-terms {
        color: #3e8cfa;
        font-size: 12px;
        margin: 0 2px;
      }
    }
  }
  &-form {
    width: 100%;
    .lls-form-item {
      // margin-bottom: 20px;
    }
    ::v-deep .lls-form-item__label {
      color: #000;
    }
    ::v-deep .lls-input__inner {
      border-radius: 8px;
    }
    ::v-deep .lls-input-group__append {
      background-color: #fff;
      border-radius: 0 8px 8px 0;
      text-align: center;
      width: 40px;
      font-size: 12px;
      .send-button:not(.is-disabled) {
        color: #3e8cfa;
      }
    }
    .appand-input {
      border-radius: 8px;
      overflow: hidden;
      ::v-deep .lls-input__inner {
        border-radius: 8px 0 0 8px;
      }
    }
  }
}
.pop-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 9px;
}
</style>
